import { PortableText } from '@portabletext/react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { SanityAdvantageProductSection } from 'graphql-types';
import React, { useState } from 'react';
import { findTranslation } from '../../utils/findTranslation';
import { usePageContext } from '../context/pageContext';
import { Blocks } from '../ui/blocks/Blocks';
import * as styles from './advantageProductSection.module.scss';

interface Props {
  section: SanityAdvantageProductSection;
}

export const AdvantageProductSection: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <Blocks blocks={findTranslation(section?._rawTextSection, lang, defaultLang)} />
      </div>
      <div className={styles.advantages}>
        {section?.advantageItemsList?.map((advantageItem, index) => {
          return (
            <div
              className={
                (section?.advantageItemsList?.length ?? 0) % 3 === 0
                  ? styles.content3
                  : styles.content4
              }
              key={`advantageItem-${index}`}
            >
              {advantageItem?.activeImage && (
                <div className={styles.image}>
                  <GatsbyImage
                    image={advantageItem?.advantageImgItem?.img?.asset?.gatsbyImageData}
                    alt={advantageItem?.advantageImgItem?.alt ?? ''}
                  />
                  <div className={styles.overlay} />
                </div>
              )}
              <h2>{findTranslation(advantageItem?._rawAdvantageTitleItem, lang, defaultLang)}</h2>
              <Blocks
                blocks={findTranslation(advantageItem?._rawAdvantageTextItem, lang, defaultLang)}
              />
            </div>
          );
        })}
      </div>
      <div className={styles.text}>
        {section?.activeText && (
          <Blocks blocks={findTranslation(section?._rawTextBottomSection, lang, defaultLang)} />
        )}
      </div>
    </div>
  );
};
